import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { selectThemeMode, toggleTheme } from '../../redux/slices/themeSlice';

const ToggleContainer = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.background.secondary};
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;

  @media (hover: hover) {
    &:hover {
      background-color: ${({ theme }) => theme.background.light};
      transform: translateY(-1px);
    }
  }

  &:active {
    transform: translateY(0);
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.primary.primary};
    outline-offset: 2px;
  }
`;

const Icon = styled.img`
  width: 20px;
  height: 20px;
  transition: all 0.3s ease;
  opacity: ${({ $active }) => ($active ? 1 : 0.6)};
  transform: ${({ $active }) => ($active ? 'scale(1.1)' : 'scale(1)')};
`;

const SunIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%)
    ${({ $active }) => ($active ? 'scale(1.1)' : 'scale(1)')};
  opacity: ${({ $active }) => ($active ? 1 : 0)};
`;

const MoonIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%)
    ${({ $active }) => ($active ? 'scale(1.1)' : 'scale(1)')};
  opacity: ${({ $active }) => ($active ? 1 : 0)};
`;

const ThemeToggle = () => {
  const dispatch = useDispatch();
  const themeMode = useSelector(selectThemeMode);

  const handleToggle = () => {
    dispatch(toggleTheme());
  };

  return (
    <ToggleContainer onClick={handleToggle} aria-label='Toggle theme'>
      <SunIcon
        src='/Sun.webp'
        alt='Light theme'
        $active={themeMode === 'light'}
      />
      <MoonIcon
        src='/moon.webp'
        alt='Dark theme'
        $active={themeMode === 'dark'}
      />
    </ToggleContainer>
  );
};

export default ThemeToggle;
